import httpClient from "./httpClient";

/**
 * * Mixed Filters - Groups, entities, products and financials
 */
const MIXED_FILTERS_DROPDOWN = "/dropdowns/proposals-filters-dropdowns";
const CLIENT_TYPE_FILTERS_DROPDOWN = "/dropdowns/client-types";
const STATES_FILTERS_DROPDOWN = "/dropdowns/proposals-states";
const DELETE_PROPOSAL = "/proposals";
const PROPOSAL_BY_ID = "/proposals/";
const GET_BM_BY_ENTITYID_DROPDOWN = "/dropdowns/business-managers/entity/";
const SAVE_PROPOSAL = "/proposals/update";
const CREATE_PROPOSAL = "/proposals/create";
const FETCH_SPANISH_COUNTRIES = "/dropdowns/country/es";
const FETCH_PORTUGUESE_COUNTRIES = "/dropdowns/country";
const FETCH_NATIONALITY_REGIMES = "/dropdowns/nationality-regime";
const FETCH_MARITAL_STATUS = "/dropdowns/marital-status/financial/";
const FETCH_MARRIAGE_TYPES = "/dropdowns/marriage-types";
const FETCH_RESIDENCE_TYPES = "/dropdowns/home-types/financial/";
const FETCH_SICK_LEAVE_REASON_TYPES = "/dropdowns/sick-leave-reason-types";
const FETCH_LEGAL_TYPES = "/dropdowns/legal-forms";
const FETCH_ACTIVITY_TYPES = "/dropdowns/business-sectors";
const FETCH_STRUCTURE_TYPES = "/dropdowns/structure-types";
const FETCH_JOB_CATEGORIES = "/dropdowns/professional-categories/financial/";
const FETCH_JOB_STATUS = "/dropdowns/professional-status/financial/";
const FETCH_JOBS = "/dropdowns/jobs/financial/";
const FETCH_COMPANY_SECTOR = "/dropdowns/company-sector/financial/";
const FETCH_STREET_TYPES = "/dropdowns/street-type";
const SUBMIT_PROPOSAL = "/proposals/send-to-financial";
const FETCH_RELATIONSHIP = "/dropdowns/relationship/financial/";
const FETCH_EMISSION_BI = "/dropdowns/doc-issuer-entities";
const DUPLICATE_PROPOSAL = "/proposals/duplicate-proposal";
const FORFEIT_PROPOSAL = "/proposals/proposal-back-out";
const FORFEIT_ID_DOC_TYPES = "/dropdowns/id-document-types";
const FORFEIT_CAE = "/dropdowns/cae";
const FETCH_CAE_BY_FIN = "/dropdowns/cae/financial/";
const CREDIBOM_CONTRACT_SIGNATURE = "/proposals/contract-signature";
const FETCH_INCOME_TYPES = "/dropdowns/income-type";
const VIDEO_IDENTIFICATION = "/proposals/video-identification";

const GET_SELLERS = "/dropdowns/sellers/entity/";

function fetchProposalsByPageOrderBy(page, orderBy, search, pageSize, entityId, idInstance) {
    const COTATION_BY_PAGE = `/proposals/entity=${entityId || -1}/financial=2/proposalType=Proposta?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(COTATION_BY_PAGE + page + orderBy + search + '&descending=true');
}

function fetchMixedDropdowns({idInstance}) {
    return httpClient.get(`${MIXED_FILTERS_DROPDOWN}?idInstance=${idInstance}`);
}

function fetchClientTypeDropdown() {
    return httpClient.get(CLIENT_TYPE_FILTERS_DROPDOWN);
}

function fetchStatesDropdown() {
    return httpClient.get(STATES_FILTERS_DROPDOWN);
}

function deleteProposal(payload) {
    return httpClient.delete(DELETE_PROPOSAL + `?idProposal=${payload?.idProposal}&gscCode=${payload?.gscCode}`);
}

function fetchProposalById(id) {
    return httpClient.get(PROPOSAL_BY_ID + id);
}

function fetchBusinessManagersByEntityId(idInstance, id = "246") {
    return httpClient.get(`${GET_BM_BY_ENTITYID_DROPDOWN + id}?idInstance=${idInstance}`);
}

function saveProposal(body) {
    return httpClient.post(SAVE_PROPOSAL, body)
}

function createProposal(body) {
    return httpClient.post(CREATE_PROPOSAL, body)
}

function fetchSpanishCountries() {
    return httpClient.get(FETCH_SPANISH_COUNTRIES)
}

function fetchPortugueseCountries() {
    return httpClient.get(FETCH_PORTUGUESE_COUNTRIES)
}

function fetchNationalityRegime() {
    return httpClient.get(FETCH_NATIONALITY_REGIMES)
}

function fetchMaritalStatus(finId) {
    return httpClient.get(FETCH_MARITAL_STATUS + finId)
}

function fetchMarriageTypes() {
    return httpClient.get(FETCH_MARRIAGE_TYPES)
}

function fetchResidenceType(finId) {
    return httpClient.get(FETCH_RESIDENCE_TYPES + finId)
}

function fetchSickLeaveReason() {
    return httpClient.get(FETCH_SICK_LEAVE_REASON_TYPES)
}

function fetchLegalType() {
    return httpClient.get(FETCH_LEGAL_TYPES)
}

function fetchActivityType() {
    return httpClient.get(FETCH_ACTIVITY_TYPES)
}

function fetchStructureType() {
    return httpClient.get(FETCH_STRUCTURE_TYPES)
}

function fetchJobCategory(finId) {
    return httpClient.get(FETCH_JOB_CATEGORIES + finId)
}

function fetchJobStatus(finId) {
    return httpClient.get(FETCH_JOB_STATUS + finId)
}

function fetchJobs(finId) {
    return httpClient.get(FETCH_JOBS + finId)
}

function fetchJobsWithCategory(finId, jobCategory) {
    return httpClient.get(FETCH_JOBS + finId + "?category=" + jobCategory)
}

function fetchCompanySector(finId) {
    return httpClient.get(FETCH_COMPANY_SECTOR + finId)
}

function submitProposal(payload) {
    return httpClient.post(SUBMIT_PROPOSAL, payload)
}

function fetchStreetTypes(finId) {
    return httpClient.get(FETCH_STREET_TYPES + "?idFinancial=" + finId)
}

function fetchCae() {
    return httpClient.get(FORFEIT_CAE)
}

function fetchCaeByFin(finId) {
    return httpClient.get(FETCH_CAE_BY_FIN + finId)
}

function fetchDocumentList(proposalId) {
    return httpClient.get(`/proposals/${proposalId}/documents-list/PRO`);
}

function deleteDocument({ idProposal, documentName }) {
    return httpClient.post(`/proposals/${idProposal}/remove-file/${documentName}`);
}

function fetchDocumentsTypes(idProposal, formNationality, idClientType = 1) {
    // https://dtogsc.atlassian.net/browse/SIFA-1459
    // Path igual para todas as financeiras, adiciou-se o idProposal
    let path = `/dropdowns/proposals-document-types?country=${formNationality}&idClientType=${idClientType}&idProposal=${idProposal}`;
    return httpClient.get(path);
}

function uploadDocument({ idProposal, documentType, base64File, clientCategory, filename }) {
    const formData = new FormData();
    formData.append('file', base64File);

    const filenamePathToAdd = filename ? `&filename=${filename}` : "";
    return httpClient.post(`/proposals/${idProposal}/upload-file/type/${documentType}?clientCategory=${encodeURIComponent(clientCategory)}` + filenamePathToAdd, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
}

function downloadDocument({ idProposal, documentName, entityId, brand }) {
    const queryParams = entityId ? `?proposalEntityId=${entityId}&brand=${brand}` : ''
    return httpClient.get(`/proposals/${idProposal}/document/${documentName}${queryParams}`, {
        headers: {
            Accept: "*/*",
        },
        responseType: "blob"
    });
}

function proposalDigitalSignature(idProposal) {
    return httpClient.post(`/proposals/${idProposal}/sofinco/request-deal-signature`);
}

function getSearchByPostalCode({ postalCode, formNationality }) {
    const proposalNationality = formNationality === "ES" ? "es" : "pt";
    return httpClient.get(`/dropdowns/search-postal-area?country=${proposalNationality}&postalCode=${postalCode}`);
}

function fetchRelationshipList(finId, query) {
    return httpClient.get(`${FETCH_RELATIONSHIP}${finId}?q=${query}`)
}

function fetchEmissionBi() {
    return httpClient.get(FETCH_EMISSION_BI);
}

function duplicateProposal(payload) {
    return httpClient.post(DUPLICATE_PROPOSAL, payload)
}

function forfeitProposal(payload) {
    return httpClient.post(FORFEIT_PROPOSAL, payload)
}

function fetchIdDocumentTypes(finId) {
    return httpClient.get(FORFEIT_ID_DOC_TYPES + '/' + finId);
}

function credibomDigitalSignature(payload) {
    return httpClient.post(CREDIBOM_CONTRACT_SIGNATURE, payload);
}

function fetchIncomeType(finId) {
    return httpClient.get(FETCH_INCOME_TYPES + '?idFinancial=' + finId);
}

function ptDigitalSignature({ idProposal, gscCode }) {
    return httpClient.post(`/proposals/work-flow/${idProposal}/${gscCode}/request-contract`);
}

function bpiProposalDocDownload(payload) {
    return httpClient.post("/proposals/print", payload, {
        headers: {
            Accept: "*/*",
        },
        responseType: "blob"
    });
}

function getSellersBy(idCurrentEntity) {
    return httpClient.get(GET_SELLERS + idCurrentEntity);
}

function getProposalLogs(idProposal) {
    return httpClient.get(PROPOSAL_BY_ID + idProposal + "/logs", {
        headers: {
            Accept: "*/*",
        },
        responseType: "blob"
    });
}

function videoIdentificationProcess(payload) {
    return httpClient.post(VIDEO_IDENTIFICATION, payload);
}

export {
    fetchProposalsByPageOrderBy, fetchMixedDropdowns,
    fetchClientTypeDropdown, fetchStatesDropdown, deleteProposal,
    fetchProposalById, fetchBusinessManagersByEntityId, saveProposal,
    createProposal, fetchSpanishCountries, fetchPortugueseCountries, fetchNationalityRegime, fetchMaritalStatus,
    fetchResidenceType, fetchJobCategory, fetchJobStatus, fetchJobs, fetchJobsWithCategory, fetchCompanySector,
    submitProposal, fetchStreetTypes, fetchCae, fetchDocumentList, uploadDocument, deleteDocument, fetchDocumentsTypes, downloadDocument,
    proposalDigitalSignature, getSearchByPostalCode, fetchRelationshipList, duplicateProposal, forfeitProposal, fetchMarriageTypes,
    fetchIdDocumentTypes, fetchEmissionBi, fetchLegalType, fetchActivityType, fetchStructureType, credibomDigitalSignature, ptDigitalSignature, bpiProposalDocDownload,
    fetchSickLeaveReason, fetchIncomeType, getSellersBy, getProposalLogs, fetchCaeByFin, videoIdentificationProcess,
}
